export default "__VITE_ASSET__BgkzkDLY__"